import React from "react";
import { holes } from "./Tiles.js";

export default class Letter extends React.Component {
  render() {
    return (
      <div
        style={{ backgroundColor: this.props.color }}
        id={this.props.id}
        
        className={
          this.props.hasWon && !holes.includes(this.props.id)
            ? "rainbow-letter"
            : "letter"
        }
        draggable={!this.props.hasWon && !holes.includes(this.props.id)} // Only draggable if not won and not a hole
        onDragStart={this.props.onDragStart} // Pass tile ID when drag starts
        onDragOver={this.props.onDragOver}   // Allow dropping
        onDrop={this.props.onDrop}           // Handle drop event
      >
        {this.props.letter}
      </div>
    );
  }
}
